import { CompanySettingsPage } from "../../settings/companySettings/company/CompanySettingsPage.tsx";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { RevSpinner } from "@revmatics/catalyst";
import { NotFoundPage } from "../../notFound/NotFoundPage.tsx";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks/hooks.ts";
import {
  editCompanyById,
  fetchCompanyById,
} from "../../../stores/thunks/companyThunk.tsx";
import { clearErrorEditCompany } from "../../../stores/slice/companySlice.tsx";

export const CompanyPage = () => {
  const { companyId } = useParams();
  const dispatch = useAppDispatch();
  const [companyName, setCompanyName] = useState("");
  const [isOpenEditCompanyName, setIsOpenEditCompanyName] = useState(false);
  const { companyById, isLoadingCompanyById } = useAppSelector(
    (state) => state.company,
  );

  useEffect(() => {
    if (
      companyId &&
      (!companyById || companyById.id.toString() !== companyId)
    ) {
      dispatch(fetchCompanyById(companyId));
    }
  }, [companyById, companyId, dispatch]);

  const handleSubmit = () => {
    if (companyId) {
      dispatch(
        editCompanyById({
          callback: () => setIsOpenEditCompanyName(false),
          body: {
            id: companyId,
            name: companyName,
          },
        }),
      );
    }
  };

  useEffect(() => {
    if (companyById) {
      setCompanyName(companyById.name);
    }
    return () => {
      dispatch(clearErrorEditCompany());
    };
  }, [companyById, dispatch]);

  if (isLoadingCompanyById) {
    return (
      <div className="h-full p-4 sm:p-6 lg:p-8 text-center">
        <RevSpinner size="large" color="primary" centered />
      </div>
    );
  }

  if (companyById) {
    return (
      <CompanySettingsPage
        handleSubmit={handleSubmit}
        companyName={companyName}
        setCompanyName={setCompanyName}
        isOpenEditCompanyName={isOpenEditCompanyName}
        setIsOpenEditCompanyName={setIsOpenEditCompanyName}
        companySettings={{
          name: companyById.name,
          id: companyById.id,
          created_at: companyById.created_at,
          updated_at: companyById.updated_at,
        }}
        brandList={companyById.brands}
        companyUsers={companyById.employees}
        backButton
      />
    );
  }
  return <NotFoundPage />;
};
